import React from 'react';
import {
    Box,
    Grid,
    Card,
    CardContent,
    Skeleton,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell
} from '@mui/material';

const DetalheProdSkeleton: React.FC = () => {
    return (
        <Box p={2}>
            <Grid container spacing={3}>
                <Grid size={{xs: 12, md: 4}}>
                    <Grid container spacing={3}>
                        <Grid size={{xs: 12}}>
                            <Card>
                                <CardContent>
                                    <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                                        <Skeleton variant="text" width={80} height={20} />
                                        <Skeleton variant="rectangular" width={50} height={24} sx={{ borderRadius: 12 }} />
                                    </Box>

                                    <Skeleton variant="text" width="100%" height={32} sx={{ mb: 3 }} />

                                    <Box mb={3}>
                                        <Box display="flex" justifyContent="space-between" mb={1}>
                                            <Skeleton variant="text" width={80} height={16} />
                                            <Skeleton variant="text" width={70} height={16} />
                                        </Box>
                                        <Box display="flex" justifyContent="space-between">
                                            <Skeleton variant="text" width={60} height={24} />
                                            <Skeleton variant="text" width={70} height={24} />
                                        </Box>
                                    </Box>

                                    <Skeleton variant="rectangular" width="100%" height={1} sx={{ my: 2 }} />

                                    <Box>
                                        {Array.from({ length: 5 }).map((_, index) => (
                                            <Box key={index} display="flex" alignItems="center" py={0.5}>
                                                <Skeleton variant="text" width={140} height={16} sx={{ flexShrink: 0 }} />
                                                <Box sx={{ flex: 1, mx: 1 }}>
                                                    <Skeleton variant="rectangular" width="100%" height={1} />
                                                </Box>
                                                <Skeleton variant="text" width={30} height={16} sx={{ flexShrink: 0 }} />
                                            </Box>
                                        ))}
                                    </Box>
                                </CardContent>
                            </Card>
                        </Grid>

                        <Grid size={{xs: 12}}>
                            <Card>
                                <CardContent>
                                    <Skeleton variant="text" width={120} height={24} sx={{ mb: 2 }} />
                                    <Skeleton variant="text" width={100} height={16} sx={{ mb: 3 }} />

                                    <Skeleton
                                        variant="rectangular"
                                        width="100%"
                                        height={200}
                                        sx={{ mb: 3, borderRadius: 1 }}
                                    />

                                    <Box display="flex" justifyContent="center">
                                        <Skeleton variant="rectangular" width={150} height={32} sx={{ borderRadius: 1 }} />
                                    </Box>
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid size={{xs: 12, md: 8}}>
                    <Grid container spacing={3}>
                        <Grid size={{xs: 12}}>
                            <Card>
                                <CardContent>
                                    <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
                                        <Skeleton variant="text" width={130} height={24} />
                                        <Skeleton variant="rectangular" width={80} height={32} sx={{ borderRadius: 1 }} />
                                    </Box>

                                    <Grid container spacing={3}>
                                        {Array.from({ length: 8 }).map((_, index) => (
                                            <Grid size={{xs: 6, md: 3}} key={index}>
                                                <Skeleton variant="text" width={80} height={16} sx={{ mb: 0.5 }} />
                                                <Skeleton variant="text" width="100%" height={20} />
                                            </Grid>
                                        ))}
                                    </Grid>
                                </CardContent>
                            </Card>
                        </Grid>

                        <Grid size={{xs: 12}}>
                            <Card>
                                <CardContent>
                                    <Skeleton variant="text" width={200} height={24} sx={{ mb: 3 }} />
                                        
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>
                                                    <Skeleton variant="text" width={60} height={20} />
                                                </TableCell>
                                                <TableCell align="center">
                                                    <Skeleton variant="text" width={80} height={20} />
                                                </TableCell>
                                                <TableCell align="center">
                                                    <Skeleton variant="text" width={90} height={20} />
                                                </TableCell>
                                                <TableCell align="center">
                                                    <Skeleton variant="text" width={90} height={20} />
                                                </TableCell>
                                                <TableCell align="center">
                                                    <Skeleton variant="text" width={50} height={20} />
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {Array.from({ length: 5 }).map((_, index) => (
                                                <TableRow key={index}>
                                                    <TableCell>
                                                        <Skeleton variant="text" width={150} height={20} />
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <Skeleton variant="text" width={30} height={20} />
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <Skeleton variant="text" width={60} height={20} />
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <Skeleton variant="text" width={60} height={20} />
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <Skeleton variant="circular" width={24} height={24} />
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Box>
    );
};

export default DetalheProdSkeleton; 